module.exports = __webpack_public_path__ + "assets/img/icon (3).962b6e7c.png";